import React from 'react';

import AKIcon, { type IconProps as AKIconProps, type CustomGlyphProps } from '@atlaskit/icon';
import ConclusionAddIcon from '@atlaskit/icon-lab/core/text-conclusion-add';
import { token } from '@atlaskit/tokens';

const IconGlyph = (props: CustomGlyphProps) => (
	<svg
		width={14}
		height="100%"
		viewBox="0 0 14 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		className={props.className}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		style={props.style}
		aria-label={props['aria-label']}
		aria-hidden={props['aria-hidden']}
		focusable={props.focusable}
		role={props.role}
		tabIndex={props.tabIndex}
		data-testid={props['data-testid']}
		id={props.id}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15 6.49999L1 6.49999L1 4.99999L15 4.99999V6.49999ZM15 2.49999L1 2.49999L1 0.999987L15 0.999987L15 2.49999Z"
			fill="currentColor"
		/>
		<path
			d="M1.75 11C2.16421 11 2.5 10.6642 2.5 10.25C2.5 9.83578 2.16421 9.49999 1.75 9.49999C1.33579 9.49999 1 9.83578 1 10.25C1 10.6642 1.33579 11 1.75 11Z"
			fill="currentColor"
		/>
		<path
			d="M1.75 15C2.16421 15 2.5 14.6642 2.5 14.25C2.5 13.8358 2.16421 13.5 1.75 13.5C1.33579 13.5 1 13.8358 1 14.25C1 14.6642 1.33579 15 1.75 15Z"
			fill="currentColor"
		/>
		<path
			d="M5.625 10.25C5.625 10.6642 5.28921 11 4.875 11C4.46079 11 4.125 10.6642 4.125 10.25C4.125 9.83578 4.46079 9.49999 4.875 9.49999C5.28921 9.49999 5.625 9.83578 5.625 10.25Z"
			fill="currentColor"
		/>
		<path
			d="M4.875 15C5.28921 15 5.625 14.6642 5.625 14.25C5.625 13.8358 5.28921 13.5 4.875 13.5C4.46079 13.5 4.125 13.8358 4.125 14.25C4.125 14.6642 4.46079 15 4.875 15Z"
			fill="currentColor"
		/>
		<path
			d="M8.75 10.25C8.75 10.6642 8.41421 11 8 11C7.58579 11 7.25 10.6642 7.25 10.25C7.25 9.83578 7.58579 9.49999 8 9.49999C8.41421 9.49999 8.75 9.83578 8.75 10.25Z"
			fill="currentColor"
		/>
		<path
			d="M8 15C8.41421 15 8.75 14.6642 8.75 14.25C8.75 13.8358 8.41421 13.5 8 13.5C7.58579 13.5 7.25 13.8358 7.25 14.25C7.25 14.6642 7.58579 15 8 15Z"
			fill="currentColor"
		/>
		<path
			d="M11.875 10.25C11.875 10.6642 11.5392 11 11.125 11C10.7108 11 10.375 10.6642 10.375 10.25C10.375 9.83578 10.7108 9.49999 11.125 9.49999C11.5392 9.49999 11.875 9.83578 11.875 10.25Z"
			fill="currentColor"
		/>
		<path
			d="M14.25 11C14.6642 11 15 10.6642 15 10.25C15 9.83578 14.6642 9.49999 14.25 9.49999C13.8358 9.49999 13.5 9.83578 13.5 10.25C13.5 10.6642 13.8358 11 14.25 11Z"
			fill="currentColor"
		/>
	</svg>
);

export const InsertAtOrBelowIcon = (): React.JSX.Element => (
	<ConclusionAddIcon
		label=""
		spacing="spacious"
		LEGACY_fallbackIcon={(props: AKIconProps) => (
			<AKIcon
				glyph={IconGlyph}
				label={props.label}
				size={props.size}
				primaryColor={props.primaryColor}
				secondaryColor={props.secondaryColor}
				testId={props.testId}
			/>
		)}
		LEGACY_secondaryColor={token('color.icon')}
	/>
);
